import { Card, Text } from '@nike/eds';

type Country = {
  code: string;
  label: string;
};

type Address = {
  addressLine1: string;
  zipCode: string;
  city: string;
  region: string;
  country: Country;
};

export type Declarant = {
  identifier: string;
  name: string;
  address: Address;
  isBroker: boolean;
};

export function DeclarantDetails({ declarant }: { declarant: Declarant }) {
  return (
    <Card padding={24} className="declarant-details-card">
      <Text font={'title-5'} as={'h3'}>{declarant.name}</Text>
      <Text font={'subtitle-2'} as={'div'} className='details-label'>Identifier</Text>
      <Text font={'body-2'} as={'div'}>{declarant.identifier}</Text>
      <Text font={'subtitle-2'} as={'div'}>Broker: {declarant.isBroker ? 'Yes' : 'No'}</Text>
      <Text font={'subtitle-2'} as={'div'} className='details-label'>Address</Text>
      <Text font={'body-2'} as={'p'}>{declarant.address.addressLine1}</Text>
      <Text font={'body-2'} as={'p'}>{declarant.address.city}, {declarant.address.region} {declarant.address.zipCode}</Text>
      <Text font={'subtitle-2'} as={'div'} className='details-label'>Country</Text>
      <Text font={'body-2'} as={'div'}>
        {declarant.address.country.label} ({declarant.address.country.code})
      </Text>
    </Card>
  );
}